import styled from '@emotion/styled';
export const FooterContainer = styled.footer`
	// border-top: 1px solid #e9ecef;
	background-color: #222;
`;

export const FooterWrapper = styled.footer`
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;

	padding: 2.5rem 0rem;
	margin: 0 auto;

	@media (max-width: 1225px) {
		padding: 2.4rem 2rem;
	}
`;
export const FooterContent = styled.div`
	display: flex;
	gap: 3.6rem;

	@media (max-width: 1225px) {
		flex-direction: column;
		gap: 2.4rem;
	}
`;

export const FooterContact = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;

	@media (max-width: 1225px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.4rem;
	}
`;
export const FooterTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	color: #ffffff;
	line-height: 160%;
	letter-spacing: -0.6px;
`;

export const FooterInfo = styled.p`
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	line-height: 140%;
	color: #DCDCDC;
	letter-spacing: -0.6px;
	white-space: pre-line;
`;

export const ImgBox = styled.div`
	width: 16rem;

	img {
		width: 100%;
	}
`;
export const FooterAbout = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 115.4rem;
	width: 100%;
	gap: 1rem;
	@media (max-width: 1225px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	@media (max-width: 1180px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.4rem;
	}
`;
export const CopyRight = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	color: #868e96;
	line-height: 100%;
	letter-spacing: -0.6px;
`;

export const FooterLogo = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.8rem;
	border: 1px solid #dee2e6;
	max-width: 14.6rem;
	width: 100%;
	margin-top: 0.6rem;
	height: 3.7rem;
	img {
		width: 100%;
	}
`;
